export default __webpack_public_path__ + "static/media/img-egt-klm.e04ff6f0.png";